import { useEffect, useState } from "react";

// material-ui

import { Box, FormControl, MenuItem, Select, Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// redux
import { useSelector } from "react-redux";
import { useDispatch } from "store";
import { setCurrentSucursalId } from "store/slices/pedidos";
import { getSucursalId, setSucursalId } from "utils/axios";

const SelectSucursal = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { sucursales } = useSelector((state) => state.negocio);
  const [currentSucursal, setCurrentSucursal] = useState();

  const sucursalActual = getSucursalId();

  const handleChange = (event) => {
    if (event.target.value.toString() !== sucursalActual) {
      setSucursalId(event.target.value.toString());
      setCurrentSucursal(event.target.value);
      window.location.reload();
    }
  };

  useEffect(() => {
    dispatch(setCurrentSucursalId(currentSucursal));
  }, [dispatch, currentSucursal]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <FormControl size="small" variant="outlined" sx={{ minWidth: 150 }}>
        {sucursales.length ? (
          <Select
            id="select-sucursal-select"
            value={sucursalActual}
            onChange={handleChange}
            sx={{
              height: 36,

              backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& .MuiSelect-select": {
                py: 1,
                px: 1.5,
                fontSize: "0.875rem",
                fontWeight: 600,
                color: theme.palette.text.primary,
              },
              "&:hover": {
                backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[50],
                transform: "translateY(-1px)",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              },
              transition: "all 0.2s ease-in-out",
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1,
                  maxHeight: 300,
                  border: `1px solid ${theme.palette.divider}`,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                  "& .MuiMenuItem-root": {
                    px: 2,
                    py: 1.5,
                    fontSize: "0.875rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[100],
                    },
                    "&.Mui-selected": {
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      "&:hover": {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    },
                  },
                },
              },
            }}>
            {sucursales.map((sucursal) => (
              <MenuItem value={sucursal.id} key={sucursal.id}>
                {sucursal.nombre}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Skeleton animation="wave" variant="rectangular" width={150} height={36} sx={{ borderRadius: 2 }} />
        )}
      </FormControl>
    </Box>
  );
};

export default SelectSucursal;
